import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <TopicsSection />
        <MediaSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
        <CardsSection />
        <AppSection />
        <CarouselSection />
        <UpdatesSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}